import { motion } from "framer-motion";
import { Flame, Users, TrendingUp } from "lucide-react";
import { IMAGES } from "@/data/site";

const reveal = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
};

export const About = () => {
  return (
    <section
      id="about"
      className="relative py-24 md:py-32 overflow-hidden"
      data-testid="about-section"
    >
      <div className="absolute top-1/2 left-0 w-[500px] h-[500px] bg-blood/10 blur-[130px] rounded-full -z-0" />

      <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-2 gap-14 items-center">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          variants={reveal}
          className="relative"
        >
          <div className="absolute -inset-4 bg-ember/20 blur-[60px] rounded-full" />
          <img
            src={IMAGES.memeChad}
            alt="The Greater Bull flexing"
            className="relative rounded-lg border border-white/10 w-full object-cover shadow-2xl"
            data-testid="about-image"
          />
        </motion.div>

        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          variants={reveal}
        >
          <span className="inline-flex items-center gap-2 text-sm font-body font-bold tracking-widest uppercase text-ember mb-4">
            <Flame className="w-4 h-4" /> The Legend
          </span>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl uppercase text-white leading-[0.95]">
            Why <span className="fire-gradient-text">$TGB?</span> Why Now?
          </h2>
          <p className="mt-6 font-body text-base md:text-lg text-gray-300 leading-relaxed">
            Every cycle has its beast. While paper hands chase the next dead cat,
            <span className="text-gold font-semibold"> The Greater Bull </span>
            charges forward — fueled by fire, forged by community, and built to run
            when everyone else is running scared.
          </p>
          <p className="mt-4 font-body text-base md:text-lg text-gray-300 leading-relaxed">
            No VCs. No insiders. No mercy. Just a fair launch on Pump.fun and an army
            of degens who refuse to sell the bottom. This isn't just a token — it's a
            movement with horns.
          </p>

          <div className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-4">
            {[
              { icon: Users, label: "Community First", sub: "100% owned by the herd" },
              { icon: TrendingUp, label: "Long Term", sub: "Built to run, not dump" },
              { icon: Flame, label: "Legendary", sub: "The next 1000x beast" },
            ].map((item, i) => (
              <div
                key={i}
                className="glass rounded-md p-4 hover:border-gold/40 transition-colors duration-300"
                data-testid={`about-feature-${i}`}
              >
                <item.icon className="w-6 h-6 text-gold mb-2" />
                <p className="font-body font-bold text-white text-sm uppercase tracking-wide">
                  {item.label}
                </p>
                <p className="font-body text-xs text-gray-400 mt-1">{item.sub}</p>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};
